module.exports = __webpack_public_path__ + "static/media/gray_16.1acb4ce2.jpg";